import get from 'lodash/get';

import store from 'Redux/store';
import { itemsToApplyVoucherTo } from 'Reselects/cartcalc';
import { currencyCode } from 'Helpers/Geo/data';

export const FREE_PRODUCTS = 'frontend/product/FREE_PRODUCTS';

export function findValidFreeProduct(product, freeProducts, productPage) {
  if (!product) {
    return null;
  }

  return freeProducts.filter((promo) => {
    const { voucherApplyArray } = itemsToApplyVoucherTo({
      voucher: promo,
      pickAndMixAll: store.getState().pickAndMix.all,
      cartItems: [product],
    });

    if (productPage && !promo.product_visibility) {
      return false;
    }

    if (promo.partnerBrand && store.getState().siteBrand !== promo.partnerBrand) {
      return false;
    }

    const minSpend = get(promo.min_spend, currencyCode);
    if (minSpend && minSpend > 0) {
      const poductPrice = get(product.currentPrice, currencyCode);
      if (minSpend > poductPrice) return false;
    }

    const maxSpend = get(promo.max_spend, currencyCode);
    if (maxSpend && maxSpend > 0) {
      const poductPrice = get(product.currentPrice, currencyCode);
      if (poductPrice > maxSpend) return false;
    }

    if (voucherApplyArray.filter(prod => prod._id === product._id).length) {
      return true;
    }

    return false;
  });
}

const getRepeatingQuantity = (freeProduct, total) => {
  if (!freeProduct.multiple) {
    return 1;
  }

  if (!freeProduct.min_spend || !freeProduct.min_spend[currencyCode]) {
    return 1;
  }

  return Math.min(Math.floor(total / (freeProduct.min_spend[currencyCode] / 100)), 5);
};

export function findValidCartFreeProduct(cartItems, freeProducts, total) {
  return freeProducts.filter((promo) => {
    const { voucherApplyArray } = itemsToApplyVoucherTo({
      voucher: promo,
      pickAndMixAll: store.getState().pickAndMix.all,
      cartItems,
    });

    if (promo.partnerBrand && store.getState().siteBrand !== promo.partnerBrand) {
      return false;
    }

    const minSpend = get(promo.min_spend, currencyCode);
    let minSpendTestPassed = true;
    if (minSpend && minSpend > 0) {
      minSpendTestPassed = (total >= (minSpend / 100));
    }
    if (!minSpendTestPassed) {
      return false;
    }

    const maxSpend = get(promo.max_spend, currencyCode);
    let maxSpendTestPassed = true;
    if (maxSpend && maxSpend > 0) {
      maxSpendTestPassed = (total <= (maxSpend / 100));
    }
    if (!maxSpendTestPassed) {
      return false;
    }

    return !!voucherApplyArray.length;
  }).map((promo) => {
    const quantity = getRepeatingQuantity(promo, total);

    return { quantity, ...promo };
  });
}
